import { useState } from "react"
import "./Snapshots.css"

// Build-time generated metadata: public images list with hashes, and asset hash map
let publicImages = []
let assetHashMap = {}
try {
  const pub = require("../../data/publicImages.json")
  if (Array.isArray(pub)) {
    // pub entries are { file: 'name.jpg', hash: '...' }
    publicImages = pub.map((e) => ({ file: e.file, hash: e.hash }))
  }
} catch (err) {
  publicImages = []
}

try {
  assetHashMap = require("../../data/assetImageHashes.json")
} catch (err) {
  assetHashMap = {}
}

// Load images from src/assets (webpack require.context).
// We'll keep the module keys so we can get original basenames for hashing.
const req = require.context("../../assets", false, /\.(jpe?g|png|webp|svg)$/)
const assetPairs = req.keys().map((k) => ({ name: k.replace(/^\.\//, ""), src: req(k) }))
const images = assetPairs.filter(({ name }) => {
  const file = name.toUpperCase()
  return !file.startsWith("AWARD") && !file.includes("INDEX") && !file.startsWith("FACEBOOK") && !file.startsWith("INSTAGRAM")
})

// Combine assets images and public images, de-duplicate by content-hash when available,
// otherwise fall back to filename dedupe. Output array of { src, name, hash }
const combinedImages = (() => {
  const seen = new Set()
  const out = []

  const pushAsset = ({ name, src }) => {
    const keyName = name.toLowerCase()
    const hash = assetHashMap[keyName] || null
    if (hash) {
      if (seen.has(hash)) return
      seen.add(hash)
    } else {
      if (seen.has(`name:${keyName}`)) return
      seen.add(`name:${keyName}`)
    }
    out.push({ src, name, hash })
  }

  const pushPublic = ({ file, hash }) => {
    const src = `/${file}`
    if (hash) {
      if (seen.has(hash)) return
      seen.add(hash)
    } else {
      const keyName = file.toLowerCase()
      if (seen.has(`name:${keyName}`)) return
      seen.add(`name:${keyName}`)
    }
    out.push({ src, name: file, hash })
  }

  images.forEach(pushAsset)
  publicImages.forEach(pushPublic)
  return out
})()

const Snapshots = ({ language }) => {
  const [selected, setSelected] = useState(null)
  const content = {
    en: {
      title: "Snapshots",
      subtitle: "Gallery of Governor's Work and Achievements",
    },
    ha: {
      title: "Hotuna",
      subtitle: "Jerin hotuna na ayyukan Gwamna da abubuwan da aka samu",
    },
  }

  const currentContent = content[language]

  return (
    <div className="snapshots">
      <div className="snapshots-header">
        <h1>{currentContent.title}</h1>
        <p>{currentContent.subtitle}</p>
      </div>

      <div className="snapshots-container">
        <div className="gallery-wrapper">
          <div className="animated-gallery">
            {combinedImages.map((item, index) => (
              <div key={index} className="snapshot-item" style={{ animationDelay: `${index * 0.05}s` }}>
                <img
                  src={item.src}
                  alt={item.name ? item.name : `Snapshot ${index + 1}`}
                  onClick={() => setSelected({ item, index })}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {selected && (
        <div className="snapshot-modal-overlay" onClick={() => setSelected(null)}>
          <div className="snapshot-modal" onClick={(e) => e.stopPropagation()}>
            <button className="snapshot-modal-close" onClick={() => setSelected(null)} aria-label="Close">✕</button>
            <div className="snapshot-modal-content">
              <img src={selected.item.src} alt={selected.item.name ? selected.item.name : `Snapshot ${selected.index + 1}`} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Snapshots
